import moment from 'moment'
import { SalaryCalculationItem } from '../../../api/salaryCalculation'

export const getEarliestItemsDate = (data: SalaryCalculationItem[]): string | undefined => {
  return data.reduce((memo, currentEntry, index) => {
    if (index === 0 || moment(currentEntry.date).isBefore(moment(memo.date))) {
      return currentEntry
    }

    return memo
  }, {} as Partial<SalaryCalculationItem>).date
}
